
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

export default function Pagination({ totalItems, itemsPerPage, currentPage, onPageChange }) {
    const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    const chunkSize = 5;

    // Calculate chunk start and end
    const chunkStart = Math.floor((currentPage - 1) / chunkSize) * chunkSize + 1;
    const chunkEnd = Math.min(chunkStart + chunkSize - 1, totalPages);

    const pageNumbers = [];
    for (let i = chunkStart; i <= chunkEnd; i++) {
        pageNumbers.push(i);
    }

    return (
        <div className="flex items-center justify-between border-gray-200 px-4 py-3 sm:px-6">
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div>
                    <p className="text-sm text-gray-700">
                        Showing <span className="font-medium">{(currentPage - 1) * itemsPerPage + 1}</span> to{" "}
                        <span className="font-medium">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of{" "}
                        <span className="font-medium">{totalItems}</span> results
                    </p>
                </div>
                <div>
                    <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-sm">
                        {/* Previous Button */}
                        <button
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className={`w-10 h-10 flex items-center justify-center text-gray-400 border border-gray-300 hover:bg-gray-50 ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                        >
                            <ChevronLeftIcon className="w-5 h-5" />
                        </button>

                        {/* Page Number Buttons */}
                        {pageNumbers.map((number) => (
                            <button
                                key={number}
                                onClick={() => onPageChange(number)}
                                className={`w-10 h-10 flex items-center justify-center text-sm font-semibold border border-gray-300 ${currentPage === number
                                    ? "bg-blue-600 text-white border-indigo-600"
                                    : "text-gray-900 hover:bg-gray-50"
                                    }`}
                            >
                                {number}
                            </button>
                        ))}

                        {/* Next Button */}
                        <button
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className={`w-10 h-10 flex items-center justify-center text-gray-400 border border-gray-300 hover:bg-gray-50 ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                        >
                            <ChevronRightIcon className="w-5 h-5" />
                        </button>
                    </nav>
                </div>
            </div>
        </div>
    );
}





